import { request, setStoredToken, clearStoredToken, setCurrentTenantId, setCurrentEnterpriseId } from './client';

/**
 * 用户登录
 * @param {Object} credentials - {username, password}
 */
export const login = async (credentials) => {
  const user = await request('/auth/login', {
    method: 'POST',
    body: credentials,
    skipAuth: true,
    skipTenant: true, // 登录时不需要租户头
  });
  // 后端返回的是用户对象，token在user.token中
  if (user?.token) {
    setStoredToken(user.token);
  }
  // 设置租户和企业ID
  if (user?.tenantId) {
    setCurrentTenantId(user.tenantId);
  }
  if (user?.enterpriseId) {
    setCurrentEnterpriseId(user.enterpriseId);
  }
  return user;
};

/**
 * 用户注册
 * @param {Object} payload - 注册信息
 */
export const register = async (payload) => {
  const result = await request('/auth/register', {
    method: 'POST',
    body: payload,
    skipAuth: true,
    skipTenant: true, // 注册时不需要租户头
  });
  // 注册成功后如果返回了 token，设置 token 和租户信息
  if (result?.token) {
    setStoredToken(result.token);
  }
  if (result?.tenantId) {
    setCurrentTenantId(result.tenantId);
  }
  if (result?.enterpriseId) {
    setCurrentEnterpriseId(result.enterpriseId);
  }
  return result;
};

/**
 * 发送验证码
 * @param {Object} params - {phone, codeType}
 * 注意：后端使用@RequestParam接收，POST请求会将参数放在URL查询字符串中
 */
export const sendVerifyCode = async ({ phone, codeType }) => {
  return request('/auth/send-code', {
    method: 'POST',
    params: { phone, codeType },
    skipAuth: true,
    skipTenant: true, // 发送验证码时不需要租户头
  });
};

/**
 * 获取当前用户信息
 */
export const fetchCurrentUser = async () => {
  return request('/auth/info', {
    method: 'GET',
  });
};

/**
 * 用户登出
 */
export const logout = async () => {
  try {
    await request('/auth/logout', {
      method: 'POST',
    });
  } finally {
    clearStoredToken();
  }
};
